import React, {useEffect} from 'react'
import './TermsAndConditions.css'
import Logo from "../Images/logo.png";
import { NavLink, Link } from 'react-router-dom';

export default function ContactInformation() {

   useEffect(() => {
    window.scrollTo(0, 0);
}, []); 

    return (
      <>
      <div className='termsAndConditionLogo'>
        <Link to="/" >
          <img src={Logo} alt='error' />
        </Link>
      </div>
      <div className='contact-information-container'>
      <h1>Contact Information</h1>

      <h2>1. Business Address:</h2>
      <ul>
        <li>Sheikhupura, Province Punjab, Country Pakistan</li>
      </ul>

      <h2>2. Email Address:</h2>
      <ul>
        <li><a href="mailto:support.dayrine@gmail.com" target="_blank" rel="noopener noreferrer">support.dayrine@gmail.com</a></li>
      </ul>

      <h2>3. Phone and WhatsApp Number:</h2>
      <ul>
        {/* <li>Phone Number: +92326-5292748</li> */}
        <li>WhatsApp Number: <a href={"tel:+923265292748"}>+92326-5292748</a> (Direct calls are welcomed, but Text via WhatsApp is preferred.)</li>
      </ul>

      <h2>4. Social Media:</h2>
      <ul style={{display:'flex', gap:'3rem'}}>
        <li style={{display:'flex', gap:'0.5rem', justifyContent:'center', alignItems: 'center', color:'#0cce53', cursor:'pointer'}}><i class="ri-whatsapp-fill"></i><a href="https://wa.me/923265292748" target="_blank" rel="noopener noreferrer">WhatApp</a></li>
        <li style={{display:'flex', gap:'0.5rem', justifyContent:'center', alignItems: 'center', color:'blue', cursor:'pointer'}}><i class="ri-facebook-circle-fill"></i><a href="https://www.facebook.com/61576407604023/" target="_blank" rel="noopener noreferrer">Facebook</a></li>
        <li style={{display:'flex', gap:'0.5rem', justifyContent:'center', alignItems: 'center', color:'red', cursor:'pointer'}}><i class="ri-youtube-fill"></i><a href="https://m.youtube.com/@dayrinestore" target="_blank" rel="noopener noreferrer">Youtube</a></li>
        {/* <li><a href="https://www.instagram.com/inpkonlineshop.official/" target="_blank" rel="noopener noreferrer">Instagram</a></li>
        <li><a href="https://www.tiktok.com/@inpkonlineshop?_t=ZT-8v0ledlhzfH&_r=1" target="_blank" rel="noopener noreferrer">Tiktok</a></li> */}
      </ul>

      <h2>5. Availability:</h2>
      <ul>
        <li>We are available 24/7 for your convenience. Feel free to reach out to us anytime.</li>
      </ul>

      <h2>6. Contact Form on Website:</h2>
      <ul>
        <li>
          Our website features a contact form for easy communication. Users can provide their full name, contact or WhatsApp number, email address, and leave a message. Clicking the "Send" button will redirect users to WhatsApp, allowing them to send messages or initiate contact easily.
        </li>
      </ul>

      <h2>7. Customer Support:</h2>
      <ul>
        <li>
          While we currently do not have a dedicated customer support team, Muhammad Ali Raza personally handles all inquiries. You can reach out via email, WhatsApp, or social media for any assistance or queries.
        </li>
      </ul>

      <p>Feel free to use any of the provided contact methods, and we look forward to assisting you.</p>
    </div>
      </>
    );
  }